import { useState } from 'react';
import InstallmentPanel from './InstallmentPanel';
import useInitialFetch from '../../services/api/useInitialFetch';
import useCart from '../Cart/useCart';
import Panel from '../../components/Panel/Panel';
import LoadingWrapper from '../../components/Loading/LoadingWrapper';
import InstallmentPanelLoading from './InstallmentPanelLoading';

function InstallmentPanelContainer() {
  const { storeId, total } = useCart();
  const [installments, setInstallments] = useState<Installment[]>([]);

  const loading = useInitialFetch(
    async (api) => {
      if (storeId) {
        const installmentResponse = await api.getInstallments(storeId, total);
        setInstallments(installmentResponse.installments);
      }
    },
    [storeId]
  );

  return (
    <Panel>
      <LoadingWrapper loadingComponent={<InstallmentPanelLoading />} loading={loading || !storeId}>
        <InstallmentPanel installments={installments} />
      </LoadingWrapper>
    </Panel>
  );
}

export default InstallmentPanelContainer;
